module.exports = __webpack_public_path__ + "static/media/favicon.d1e7b2ad.ico";